<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>إذن استلام بضاعة</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
            هنا يتم عرض جميع اذونات استلام البضاعة
              <div class='pull-left' style='padding=0px'>
                <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                  <b>  إضافة جديد </b>
                </button>
              </div>
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' v-if='mainValidationErrors'>
                <ul v-if='mainValidationErrors'>
                    <li v-for='err in mainValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='col-lg-12' style="margin:10px;padding:0px">
                <div class='col-lg-3 col-md-3 col-sm-3'>
                      <label>الفرع</label>
                      <select class="form-control"  v-model="branch_id">
                        <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                          {{ item.name }}
                        </option>
                      </select>
                </div>

                <div class='col-lg-3 col-md-3 col-sm-3'>
                  <tbDate  :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-3'>
                  <tbDate  :mytitle='toTitle' v-model= 'date_to' ></tbDate>
                </div>
                <div class='form-group col-lg-2 col-sm-2'>
                  <label>النوع:</label>
                  <select class="form-control" style="padding: 0px" v-model="status">
                    <option v-for="type in types" v-bind:key="type.id" v-bind:value="type.id">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
                    <div style="padding-top:25px" class='col-lg-1 col-md-1 col-sm-6'>
                        <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                          <b> عرض </b>
                        </button>
                    </div>
              </div>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>

                    <th style='text-align: center'>كود الفاتورة</th>
                    <th style='text-align: center'>رقم الفاتورة</th>
                    <th style='text-align: center'>تاريخ الفاتورة</th>
                    <th style='text-align: center'>المورد</th>
                    <th style='text-align: center'>أمين المخزن</th>
                    <th style='text-align: center'>رقم فاتورة المورد</th>
                    <th style='text-align: center'>تاريخ فاتورة المورد</th>
                    <th style='text-align: center'>الحالة</th>
                    <th style='text-align: center'>ملاحظات</th>
                    <th style='text-align: center'>الاجراء</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='record in records' :key='record.id'>
                    <td align='center'>{{record.id}}</td>
                    <td align='center'>{{record.invoic_id}}</td>
                    <td align='center'>{{record.invoic_date}}</td>
                    <td align='center'>{{record.vendor_name}}</td>
                    <td align='center'>{{record.storekeeper_name}}</td>
                    <td align='center'>{{record.vendor_invoice_id}}</td>
                    <td align='center'>{{record.vendor_invoice_date}}</td>
                    <td v-show="parseInt(record.status) === 0" align='center'><code>غير مرحل</code></td>
                    <td v-show="parseInt(record.status) !== 0" align='center'>مرحل</td>
                    <td align='center'>{{record.notes}}</td>
                    <td align='center'>
                      <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                      <button v-show="parseInt(record.status) === 0" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                      <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>عرض</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class='form-group col-lg-6 col-md-6  col-sm-6' style="margin:0px;padding:0px">
                  <div class='form-group col-lg-6 col-md-6 col-sm-12'>
                    <label>الفرع:</label>
                    <select @change='changeBranche()' class="form-control" style="padding: 0px" v-model="record.branche_id">
                      <option v-for="branch in branches" v-bind:key="branch.id" v-bind:value="branch.id">
                        {{ branch.name }}
                      </option>
                    </select>
                  </div>
                  <div class='form-group col-lg-6 col-md-6 col-sm-12'>
                    <label>المورد:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.vendor_id">
                      <option v-for="vendor in vendors" v-bind:key="vendor.id" v-bind:value="vendor.id">
                        {{ vendor.name }}
                      </option>
                    </select>
                  </div>
                  <div class='form-group col-lg-6 col-md-6 col-sm-12'>
                    <label>رقم فاتورة المورد:</label>
                    <input v-model='record.vendor_invoice_id' class='form-control' name='vendor_invoice_id' type='text'>
                  </div>
                  <div class='form-group col-lg-6 col-md-6 col-sm-12'>
                    <tbDate  :mytitle='dateVendoerTitle' v-model= 'record.vendor_invoice_date' ></tbDate>
                  </div>
                  <div class='form-group col-lg-6 col-md-6 col-sm-12'>
                    <label>رقم الفاتورة:</label>
                    <input v-model='record.invoic_id' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div class='form-group col-lg-6 col-md-6 col-sm-12'>
                    <tbDate  :mytitle='dateTitle' v-model= 'record.invoic_date' ></tbDate>
                  </div>
                  <div class='form-group col-lg-12 col-sm-12'>
                    <label>ملاحظات:</label>
                    <input v-model='record.notes' class='form-control' name='notes' type='text'>
                  </div>
                  <div v-show="parseInt(record.status) === 0" class='form-group col-lg-12 col-sm-12'>
                    <button @click='saveData' type='button' class='btn btn-outline btn-primary btn-block'>حفظ بيانات الفاتورة</button>
                  </div>

                </div>
                <div v-show="record.id > 0" class='form-group col-lg-6 col-md-6  col-sm-6' style="padding: 0px 5px 0px 5px">
                  <div class='form-group col-lg-6 col-md-6 col-sm-12' style="padding: 0px 5px 0px 5px">
                    <label>الصنف:</label>
                    <select  ref="item_id" class="form-control" style="padding: 0px" v-model="item_id">
                      <option v-for="item in items" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.item }}
                      </option>
                    </select>
                  </div>
                  <div class='form-group col-lg-6 col-md-6 col-sm-12' style="padding: 0px 5px 0px 5px">
                    <label>المخزن:</label>
                    <select class="form-control" style="padding: 0px" v-model="store_id">
                      <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">
                        {{ store.name }}
                      </option>
                    </select>
                  </div>
                  <div class='form-group col-lg-6 col-md-6  col-sm-12'   style="padding: 0px 5px 0px 5px">
                    <label>الكمية:</label>
                    <input v-model='amount' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div v-show="parseInt(record.status) === 0" class='form-group col-lg-6 col-md-6  col-sm-12' style="padding: 23px 5px 0px 5px">
                    <button @click='saveInvoiceItem' type='button' class='btn btn-outline btn-primary btn-block'>حفظ الصنف للفاتورة</button>
                  </div>
                  <table width='100%' class='table  table-bordered ' >
                    <thead>
                      <tr>
                        <th style='text-align: center'>م</th>
                        <th style='text-align: center'>الصنف</th>
                        <th style='text-align: center'>الكمية</th>
                        <th v-show="parseInt(record.status) === 0" style='text-align: center'>الاجراء</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for='(itemRecord, index) in invoiceItems' :key='itemRecord.id'>
                        <td style="padding:2px" align='center'>{{index +1}}</td>
                        <td style="padding:2px" align='center'>{{itemRecord.item}}</td>
                        <td style="padding:2px" align='center'>{{itemRecord.amount}}</td>
                        <td v-show="parseInt(record.status) === 0" style="padding:2px" align='center'>
                          <vue-element-loading size='32' :active='isLoadingDeleteItem' spinner='bar-fade-scale' color='#A4A4A4'/>
                          <button @click='deleteItem(itemRecord.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class='col-lg-12 col-sm-12' style='padding: 0px;margin:0px'>
                  <h6 style='padding: 0px;margin:0px'>
                    <small v-show="parseInt(record.status) === 0">
                      الحالة: غير مرحل
                    </small>
                    <small v-show="parseInt(record.status) !== 0">
                    الحالة: مرحل
                    </small>
                  </h6>
                </div>
              </fieldset>
            </div>
            <div class='modal-footer'>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
              <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'purchase_masters',
  data () {
    return {
      fromTitle: 'من',
      toTitle: 'إلى',
      date_from: '',
      date_to: '',
      dateVendoerTitle: 'تاريخ فاتورة المورد',
      dateTitle: 'تاريخ الفاتورة',
      validationErrors: '',
      stores: {},
      branches: {},
      items: {},
      branch_id: '',
      records: [],
      record: {},
      vendors: {},
      invoiceItems: {},
      mainValidationErrors: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      isLoadingDeleteItem: false,
      title: '',
      amount: '',
      item_id: '',
      store_id: '',
      status: 0,
      types: [{id: 1, name: 'مرحل'}, {id: 0, name: 'غير مرحل'}]
    }
  },
  created () {
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    today = dd + '-' + mm + '-' + yyyy
    this.date_from = today
    this.date_to = today
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.items = JSON.parse(localStorage.getItem('Items'))
    this.branch_id = localStorage.getItem('BrancheID')
    this.GetVendors()
    // this.GetData()
  },
  methods: {
    changeBranche () {
      let i = this.branches.findIndex(x => x.id === parseInt(this.record.branche_id))
      if (i > -1) {
        this.stores = this.branches[i].stores
      }
    },
    GetVendors () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getVendors', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.vendors = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getPurchaseMasters', {
        token: localStorage.getItem('token'),
        branche: this.branch_id,
        date_from: this.date_from,
        date_to: this.date_to,
        status: this.status
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          this.mainValidationErrors = ''
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    getInvoiceItems () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getInvoicePurchases', {
        token: localStorage.getItem('token'),
        purchase_master_id: this.record.id
      })
        .then(({ data }) => {
          this.invoiceItems = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'branche_id': this.branch_id, 'invoic_id': '', 'invoic_date': '', 'vendor_id': '', 'storekeeper_id': '', 'vendor_invoice_id': '', 'vendor_invoice_date': '', 'status': '0', 'notes': ''}
        this.changeBranche()
        this.invoiceItems = []
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = {'id': recID.id, 'branche_id': recID.branche_id, 'invoic_id': recID.invoic_id, 'invoic_date': recID.invoic_date, 'vendor_id': recID.vendor_id, 'storekeeper_id': recID.storekeeper_id, 'vendor_invoice_id': recID.vendor_invoice_id, 'vendor_invoice_date': recID.vendor_invoice_date, 'status': recID.status, 'notes': recID.notes}
        this.changeBranche()
        this.getInvoiceItems()
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'savePurchaseMasters', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        branche_id: this.record.branche_id,
        invoic_id: this.record.invoic_id,
        invoic_date: this.record.invoic_date,
        vendor_id: this.record.vendor_id,
        vendor_invoice_id: this.record.vendor_invoice_id,
        vendor_invoice_date: this.record.vendor_invoice_date,
        notes: this.record.notes
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.record = res.data
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.record = res.data
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
            this.$refs.item_id.focus()
          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    saveInvoiceItem () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'savePurchases', {
        token: localStorage.getItem('token'),
        purchase_master_id: this.record.id,
        item_id: this.item_id,
        amount: this.amount,
        store_id: this.store_id
      })
        .then(res => {
          this.isLoadingSave = false
          this.invoiceItems.push(res.data)
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
          this.item_id = ''
          this.amount = ''
          this.$refs.item_id.focus()
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deletePurchaseMasters', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    },
    deleteItem (recID) {
      this.isLoadingDeleteItem = true
      axios.post(this.$apiURL + 'deletePurchases', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.invoiceItems.map(record => record.id).indexOf(recID)
          this.invoiceItems.splice(i, 1)
          this.isLoadingDeleteItem = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDeleteItem = false
          this.$refs.item_id.focus()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/purchases/DeliveryTicket.vue